import axiosInstance from './axiosInstance'
import { SyncOrdersRequest, SyncOrdersResponse, ScheduledStatusResponse } from '../types/homecenter'

export const syncOrders = async (data?: SyncOrdersRequest): Promise<SyncOrdersResponse> => {
  try {
    const response = await axiosInstance.post('homecenter/sync-orders', data || {})
    return response.data
  } catch (error: any) {
    console.error('Error sincronizando pedidos de Home Center:', error)
    throw error
  }
}

export const getScheduledStatus = async (): Promise<ScheduledStatusResponse> => {
  try {
    const response = await axiosInstance.get('homecenter/scheduled-status')
    return response.data
  } catch (error: any) {
    console.error('Error obteniendo estado de sincronización programada:', error)
    throw error
  }
}

export const syncOrdersByDate = async (data: SyncOrdersRequest): Promise<SyncOrdersResponse> => {
  try {
    const response = await axiosInstance.post('homecenter/sync-orders', data)
    return response.data
  } catch (error: any) {
    console.error('Error sincronizando pedidos de Home Center por fecha:', error)
    throw error
  }
}

export const enableScheduledTask = async (taskName: string = 'homeCenterSync'): Promise<any> => {
  try {
    const response = await axiosInstance.post('homecenter/enable-scheduled-task', { taskName })
    return response.data
  } catch (error: any) {
    console.error('Error activando tarea programada:', error)
    throw error
  }
}

export const disableScheduledTask = async (taskName: string = 'homeCenterSync'): Promise<any> => {
  try {
    const response = await axiosInstance.post('homecenter/disable-scheduled-task', { taskName })
    return response.data
  } catch (error: any) {
    console.error('Error desactivando tarea programada:', error)
    throw error
  }
}